import React from 'react';
import PropTypes from 'prop-types';

import {
  Modal,
  ContainerButton,
  ButtonCancel,
  ButtonConfirm,
  Text,
  Content,
} from './styles';

const CustomModal = (props) => {
  const {
    onConfirm,
    onClose,
    open,
    loading,
    text,
    confirmText,
    cancelText,
  } = props;

  return (
    <Modal
      open={open}
      onClose={onClose}
    >
      <Content>
        <Text>{text}</Text>

        <ContainerButton>
          <ButtonConfirm
            loading={loading}
            onClick={onConfirm}
            disabled={loading}
          >
            {confirmText}
          </ButtonConfirm>
          <ButtonCancel
            onClick={onClose}
            disabled={loading}
          >
            {cancelText}
          </ButtonCancel>
        </ContainerButton>
      </Content>
    </Modal>
  );
};

CustomModal.propTypes = {
  loading: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
  confirmText: PropTypes.string.isRequired,
  cancelText: PropTypes.string.isRequired,
};

export default CustomModal;
